var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("meta",function(){return [_c('div')]}),_c('v-alert',{attrs:{"elevation":"5","type":"info","icon":false}},[_c('div',{staticClass:"text-center"},[_c('v-checkbox',{attrs:{"label":_vm.contentData.Text},model:{value:(_vm.acknowledged),callback:function ($$v) {_vm.acknowledged=$$v},expression:"acknowledged"}})],1)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }